import React, { useEffect } from 'react';
import { AlertBanner } from '@flexible-reports/components/feedback';
import styled from 'styled-components';
import { Text } from '@amzn/storm-ui';

interface ErrorBannerProps {
  header: string;
  message: string;
  detailsList?: string[];
}

const ErrorList = styled.ul`
  margin: 0;
  list-style-type: disc;
`;

const ErrorListItem = styled.li`
  &:last-child {
    margin-bottom: 0;
  }
`;

export const ErrorBanner = ({ header, message, detailsList = [] }: ErrorBannerProps) => {
  const detailsContent = detailsList.length ? (
    <ErrorList>
      {detailsList.map((message, index) => (
        <ErrorListItem key={index}>
          <Text>{message}</Text>
        </ErrorListItem>
      ))}
    </ErrorList>
  ) : null;

  useEffect(() => {
    if (header || message) {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
  }, [header, message]);

  return (
    <AlertBanner variant='error' header={header} description={message}>
      {detailsContent}
    </AlertBanner>
  );
};
